import { Inject, Injectable, Injector } from '@angular/core';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';

import { Utilities_OperationService } from './Utilities.operation.service';
import { ExcelOrderImport_OperationService } from './ExcelOrderImport.operation.service';
import { TransloadOrders_OperationService } from './TransloadOrders.operation.service';
import { PurchaseOrders_OperationService } from './PurchaseOrders.operation.service';
import { FootprintApiManager_OperationService } from './FootprintApiManager.operation.service';


@Injectable({ providedIn: 'root' })
export class app_OperationService {

  constructor(
    private injector: Injector,
    private $utils: UtilsService,
  ) {
    this.Utilities = this.injector.get(Utilities_OperationService);
    this.ExcelOrderImport = this.injector.get(ExcelOrderImport_OperationService);
    this.TransloadOrders = this.injector.get(TransloadOrders_OperationService);
    this.PurchaseOrders = this.injector.get(PurchaseOrders_OperationService);
    this.FootprintApiManager = this.injector.get(FootprintApiManager_OperationService);
  }

    public Utilities: Utilities_OperationService;
    public ExcelOrderImport: ExcelOrderImport_OperationService;
    public TransloadOrders: TransloadOrders_OperationService;
    public PurchaseOrders: PurchaseOrders_OperationService;
    public FootprintApiManager: FootprintApiManager_OperationService;
  public app: app_OperationService = this;


  private isAuthorized(operationName: string): Promise<boolean> {
    return this.$utils.http.post(`${environment.backendUrl}api/app/operations/${operationName}/isauthorized`, null);
  }
}
